module.exports = __webpack_public_path__ + "img/ChingShin.0275fe30.svg";